import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import {Link} from '@reach/router';
import FlickitySlider from "./FlickitySlider";

class HiliteSlider extends Component{
  render(){
    var slideItem = [];
    this.props.data.forEach((item, index) => {
        let classname = item.type == 'promo' ? "carousel-cell ci-promo" : "carousel-cell";
        let text = item.title ? (<div className="slider-text"><div>{item.title}</div></div>) : '';
      slideItem.push(
          <div className={classname} key={'hi_' + index}>
            <Link to={item.url}>
              <div className="slider-img">
                <img src={item.image} />
                  {item.playicon &&
                  <img className="btn-play-video" src="https://app.triyakom.com/artist_portal/old/btn-play-video.svg"/>
                  }
                <div className="hlite-grad"></div>
              </div>
            </Link>
              {text}
          </div>
      );
    });

    return(
      <>
          <FlickitySlider options={{ "freeScroll": true, "contain": true, "prevNextButtons": false, "pageDots": false }}>
        {slideItem}
        <div className="div-last-slider"></div>
      </FlickitySlider>
      </>
    );
  }
}

export default HiliteSlider;
